import { copApi } from 'api'
import { VisibilityPreferences } from 'types/visibility-preferences'

export interface Props {
  practitionerId: string
  preference: VisibilityPreferences
}

export const patchVisibilityPreferences = ({ practitionerId, preference }: Props) =>
  copApi.patch<{ id: string; preference: Props['preference'] }>(`/practitioners/${practitionerId}/visibility`, {
    preference,
  })
